__turbopack_context__.v({
  "article-grid": "xm11rG_article-grid",
  "articles-container": "xm11rG_articles-container",
  "filter": "xm11rG_filter",
  "news-card-grid": "xm11rG_news-card-grid",
  "paginated-story-grid-section": "xm11rG_paginated-story-grid-section",
  "pagination": "xm11rG_pagination",
  "title": "xm11rG_title",
});
